<div class="already-accepted-wrapper">
    <div [ngSwitch]="state">
        <div *ngSwitchCase="eInvitation.Account">
            <h1>{{'Vous avez deja accepte l\'invitation' | transloco}}</h1>
            <p
                    [innerHTML]="'Vous avez deja rejoint l\'organisation <strong> $productName$</strong>' | transloco: { productName: invitation?.account?.organization_name  | escapeHtml}">
            </p>
            <signup-card-link [data]="cardLinkData" [modeButton]="true"></signup-card-link>
        </div>
        <div *ngSwitchCase="eInvitation.Ksuite">
            <h1>{{'Cette invitation a deja ete acceptee' | transloco}}</h1>
            <p
                    [innerHTML]="'Veuillez vous connecter a votre compte ou, acceder directement au manager.' | transloco">
            </p>
            <signup-card-link [data]="cardLinkData" [modeButton]="true"></signup-card-link>
        </div>
        <div *ngSwitchCase="eInvitation.KsuiteMailbox">
            <h1>{{'Cette invitation a deja ete acceptee' | transloco}}</h1>
            <p
                    [innerHTML]="'Veuillez vous connecter a votre compte ou, acceder directement au manager.' | transloco">
            </p>
            <signup-card-link [data]="cardLinkData" [modeButton]="true"></signup-card-link>
        </div>
        <div *ngSwitchCase="eInvitation.Drive">
            <h1>{{'Vous avez deja accepte l\'invitation' | transloco}}</h1>
            <p
                    [innerHTML]="'Vous avez deja rejoint le drive <strong>$productName$</strong>' | transloco: { productName: invitation?.extras?.drive?.name  | escapeHtml}">
            </p>
            <signup-card-link [data]="cardLinkData"></signup-card-link>
        </div>
        <div *ngSwitchCase="eInvitation.Webmail">
            <h1>{{'Vous avez deja accepte l\'invitation' | transloco}}</h1>
            <p
                    [innerHTML]="'Vous accedez deja a l\'adresse email <strong>$productName$</strong>' | transloco: { productName: invitation?.extras?.webmail?.email  | escapeHtml}">
            </p>
            <signup-card-link [data]="cardLinkData"></signup-card-link>
        </div>
        <div *ngSwitchCase="eInvitation.KChat">
            <h1>{{'L\'invitation a expiré' | transloco}}</h1>
            <p
                    [innerHTML]="'Veuillez contacter un administrateur afin qu’il vous fasse parvenir une nouvelle invitation.' | transloco">
            </p>
            <signup-card-link [data]="cardLinkData"></signup-card-link>
        </div>
        <div *ngSwitchCase="eInvitation.Webmail1">
            <h1>{{'Vous avez deja accepte l\'invitation' | transloco}}</h1>
        </div>
        <div *ngSwitchCase="eInvitation.Transfer">
            <h1>{{'Vous avez deja accepte le transfert de produit' | transloco}}</h1>
            <div
                    *ngIf="invitation?.extras?.destination_account?.organization_name; else without_account">
                <p
                        [innerHTML]="'Vous avez deja transfere le produit vers l\'organisation <strong> $productName$</strong>' | transloco: { productName: invitation?.extras?.destination_account?.organization_name  | escapeHtml}">
                </p>
            </div>
            <ng-template #without_account>
                <p
                        [innerHTML]="'Vous avez deja transfere le produit' | transloco"></p>
            </ng-template>
            <signup-card-link [data]="cardLinkData"></signup-card-link>
        </div>
    </div>
    <div class="right-side">
        <img *ngIf="state !== eInvitation.KChat"  alt="invitation illustration" src="assets/images/invitations/invitation-illu.svg"/>
        <img *ngIf="state === eInvitation.KChat" alt="invitation illustration" src="assets/images/ui/tools/ik-kchat-invitation-expired.svg"/>
    </div>
</div>
